// extracted by mini-css-extract-plugin
export default {"halfCircle":"master_halfCircle__8cwIW","border":"master_border__B2aLo"};